/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { Button, InlineLoading } from 'carbon-components-react';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { ApiStatus } from '@ibm-watson/shared/ts';
import { RootState } from '@ibm-watson/shared/ts/state';
import { selectCreateStatus } from '../../../store/voice/selectors';
import { Speech as messages } from '../messages';

import './CreateSpeechInstanceButton.scss';

interface CreateSpeechInstanceButtonProps {
  statusSelector: (state: RootState) => ApiStatus;
  create: () => void;
}
export const CreateSpeechInstanceButton = ({
  statusSelector,
  create
}: CreateSpeechInstanceButtonProps) => {
  const intl = useIntl();
  const createStatusProps = useSelector((state: RootState) =>
    selectCreateStatus(state, intl, statusSelector)
  );
  return (
    <>
      {createStatusProps.status !== 'inactive' ? (
        <InlineLoading
          className="CreateSpeechInstanceButtonProps__loading"
          {...createStatusProps}
        />
      ) : (
        <Button kind="tertiary" onClick={create}>
          {intl.formatMessage(messages.createButtonLabel)}
        </Button>
      )}
    </>
  );
};
